



















































import { mapGetters } from 'vuex';
import DescomplicaLogo from '@/dex-shared/components/icons/DescomplicaLogo.vue';
import { descomplicaURL } from '@/dex-shared/settings/endpoints';

export default {
  components: {
    DescomplicaLogo,
  },

  computed: {
    ...mapGetters({
      userId: 'userId',
      userLastCourse: 'userLastCourse',
    }),
    courseUrl() {
      if (!this.userLastCourse) return descomplicaURL;

      return `${descomplicaURL}/cursos/${this.userLastCourse.slug}`;
    },
    profileUrl() {
      return `${descomplicaURL}/configuracoes`;
    },
  },
};
